import type {
  GetDeviceConfigurationByOrganizationV1QueryResponseApi,
  SwapManagementTypeEnumApi,
} from '@ingenico/api-sdk-provisioning-private';
import type {
  AttachmentListResponseApi,
  LogicalDeviceSwappableResourceApi,
} from '@ingenico/api-sdk-provisioning-public';
import type { MappedAttachmentsResponseApi } from '../../models/attachments.model';

export function mapAttachmentsList(response: AttachmentListResponseApi): MappedAttachmentsResponseApi {
  return {
    ...response,
    data: response?.data?.map((attachment) => ({
      id: attachment?.id,
      logicalDeviceIdentifier: attachment?.logicalDeviceIdentifier,
      logicalDeviceTypeIdentifier: attachment?.logicalDeviceTypeIdentifier,
      physicalDeviceIdentifier: attachment?.physicalDeviceIdentifier,
      physicalDeviceTypeIdentifier: attachment?.physicalDeviceTypeIdentifier,
    })),
  };
}

export function mapAttachmentStatus(response: LogicalDeviceSwappableResourceApi): boolean {
  return response.isDeviceSwappable;
}

export function mapOrganizationSwapConfig(config: GetDeviceConfigurationByOrganizationV1QueryResponseApi): boolean {
  return config.swapManagement === ('RESTRICTED' as SwapManagementTypeEnumApi);
}
